import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form as FormikForm } from "formik";
import { Button, Row, Col } from "react-bootstrap";
import {
  FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaLock,
  FaUserPlus,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import FormField from "../components/forms/FormField";
import { registerSchema } from "../validation/schemas";
import "./Register.css";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";

const Register = () => {
  const navigate = useNavigate();
  const { register, getErrorMessage } = useAuth();

  return (
    <main className="auth-page">
      <Seo {...PAGE_SEO.register} />
      <section className="auth-card register-card">
        <div className="auth-left">
          <span className="auth-badge">Create Account</span>
          <h1>Register with SG Office</h1>
          <p>
            Create an account to manage enquiries, wishlist items, quote
            requests, and future orders.
          </p>
        </div>

        <Formik
          initialValues={{
            name: "",
            phone: "",
            email: "",
            password: "",
            confirmPassword: "",
          }}
          validationSchema={registerSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await register(values);
              toast.success("Account created. Please login.");
              navigate("/login");
            } catch (error) {
              toast.error(getErrorMessage(error, "Registration failed"));
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting }) => (
            <FormikForm className="auth-form" noValidate>
              <div className="auth-icon">
                <FaUserPlus />
              </div>

              <h2>Register</h2>

              <FormField
                name="name"
                label="Full Name"
                labelIcon={<FaUser />}
                placeholder="Enter full name"
                autoComplete="name"
              />

              <Row>
                <Col md={6}>
                  <FormField
                    name="phone"
                    type="tel"
                    label="Phone"
                    labelIcon={<FaPhoneAlt />}
                    placeholder="Phone number"
                    autoComplete="tel"
                  />
                </Col>
                <Col md={6}>
                  <FormField
                    name="email"
                    type="email"
                    label="Email"
                    labelIcon={<FaEnvelope />}
                    placeholder="Email address"
                    autoComplete="email"
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormField
                    name="password"
                    type="password"
                    label="Password"
                    labelIcon={<FaLock />}
                    placeholder="Create password"
                    autoComplete="new-password"
                  />
                </Col>
                <Col md={6}>
                  <FormField
                    name="confirmPassword"
                    type="password"
                    label="Confirm Password"
                    labelIcon={<FaLock />}
                    placeholder="Confirm password"
                    autoComplete="new-password"
                  />
                </Col>
              </Row>

              <Button
                type="submit"
                className="auth-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Creating..." : "Create Account"}
              </Button>

              <p className="auth-switch">
                Already have an account? <Link to="/login">Login</Link>
              </p>
            </FormikForm>
          )}
        </Formik>
      </section>
    </main>
  );
};

export default Register;
